module.exports = __webpack_public_path__ + "static/media/light-r-6.8655baae.png";